var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-box"},[(false)?_c('el-carousel',{attrs:{"indicator-position":"outside","height":"94px","interval":5000}},_vm._l((4),function(item){return _c('el-carousel-item',{key:item})}),1):_vm._e(),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("../../images/banner.png"),"alt":""}})])
}]

export { render, staticRenderFns }